export * from './buscador/vista-areas-mineras-digitalizacion-buscador.component';
export * from './lista/vista-areas-mineras-digitalizacion-lista.component';
